import React from 'react';
import PropTypes from 'prop-types';

import Edit from './Edit';

const ScaleField = props => <Edit {...props} />;

ScaleField.propTypes = {
  editing: PropTypes.bool.isRequired,
};

export default ScaleField;
